import system from './modules/system';
import module from './modules/module';

const api = {
    system: system,
    module: module,
};

export default api;


// WEBPACK FOOTER //
// ./src/api/index.js